// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3IniC","label":"CategoryService_label__19ixJ","location":"CategoryService_location__3pPzT"};